import { BaseFetch } from "../main-model"
export default class GradeModel extends BaseFetch {
    getGradeBy = (data) =>
    this.authFetch({
      url: "grade/getGradeBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getGradeStudentClassBy = (data) =>
    this.authFetch({
      url: "grade/getGradeStudentClassBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getGradeSubjectBy = (data) =>
    this.authFetch({
      url: "grade/getGradeSubjectBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getGradeById = (data) =>
    this.authFetch({
      url: "grade/getGradeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertGrade = (data) =>
    this.authFetch({
      url: "grade/insertGrade",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateGradeById = (data) =>
    this.authFetch({
      url: "grade/updateGradeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteGradeById = (data) =>
    this.authFetch({
      url: "grade/deleteGradeById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
